import ChatBubbleLeftRight from "@interstate/icons-svg/chat-bubble-left-right.svg?raw";
import Cog from "@interstate/icons-svg/cog-8-tooth.svg?raw";
import Plus from "@interstate/icons-svg/plus.svg?raw";
import QuestionMarkCircle from "@interstate/icons-svg/question-mark-circle.svg?raw";
import Users from "@interstate/icons-svg/users.svg?raw";
/**
 * Known icon tokens mapped to their raw SVG strings.
 *
 * Keys are the values that the BB API's `user_links[].icon` field and
 * solution configs' `ConfigUserLink.className` field are known to send.
 */
const KNOWN_ICONS: Record<string, string> = {
  "attach-more-solutions": Plus,
  "my-settings": Cog,
  "help": QuestionMarkCircle,
  "bridge-admin": Users,
  "dealer-chat": ChatBubbleLeftRight
};

/**
 * Resolve an Interstate icon name (e.g., from a `user_link.icon` API field)
 * to its raw SVG string. Returns `null` when the name is missing or unknown
 * so callers can conditionally render the icon slot.
 *
 * Pass the result into the `<InterstateIcon svg="${...}">` wrapper to render.
 */
export function resolveInterstateIcon(
  name: string | null | undefined
): string | null {
  if (!name) return null;
  return KNOWN_ICONS[name] ?? null;
}
